import PropTypes from 'prop-types';
import Image from 'next/image';

// Took from intrinsic size of images
const CAROUSEL_MOBILE_IMAGE_WIDTH = 960;
const CAROUSEL_MOBILE_IMAGE_HEIGHT = 440;

export const IMAGE_INDEX_THRESHOLD_TO_LAZYLOAD = 4;

import styles from './CarouselMobile.module.scss';
import { convertToWebPUrl } from '@/utils/productUtils';

const CarouselMobile = ({ onClickSlide, slides }) => slides?.length ? slides.map((image, index) => (
  <a
    key={image._id}
    href={image.urlDest}
    aria-label={image.alt}
    onClick={() => onClickSlide(image, index)}
    data-test-id="carousel-mobile-link"
  >
    <picture>
      <source srcSet={convertToWebPUrl(image.imgS)} type="image/webp" />
      <img
        className={styles['carousel-image']}
        src={image.imgS}
        alt={image.alt}
        height={CAROUSEL_MOBILE_IMAGE_HEIGHT}
        width={CAROUSEL_MOBILE_IMAGE_WIDTH}
        loading={index < IMAGE_INDEX_THRESHOLD_TO_LAZYLOAD ? 'eager' : 'lazy' }
      />
    </picture>
  </a>
)) : null;

CarouselMobile.propTypes = {
  onClickSlide: PropTypes.func.isRequired,
  slides: PropTypes.array.isRequired
};

export default CarouselMobile;
